import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mt-3" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-col lg:col-span-2 xl:col-span-1 gap-6 row-span-5" }
const _hoisted_6 = { class: "flex flex-col grow" }
const _hoisted_7 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_8 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_9 = { class: "flex flex-col col-span-2" }
const _hoisted_10 = { class: "flex flex-col col-span-2" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "flex flex-col justify-end lg:col-span-1" }
const _hoisted_15 = { class: "flex flex-col grow" }
const _hoisted_16 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_17 = { class: "underline text-sm text-next-atp pt-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "underline text-sm text-next-atp pt-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "underline text-sm text-next-atp pt-3" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "lg:col-span-2 xl:col-span-1 gap-6 xl:col-start-3" }
const _hoisted_26 = { class: "flex items-end justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.visible) = $event)),
    backdrop: true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Title), 1)
      ])
    ]),
    main: _withCtx(() => [
      _withDirectives(_createVNode(_component_Alert, { class: "bg-next-orange" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.alert_error), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.alert_error]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            field_name: "Azienda del gruppo",
            required: !_ctx.aziendeGruppoAutocomplete?.selection,
            errors: _ctx.getErrors('azienda_gruppo_id'),
            placeholder: "Azienda del gruppo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.aziendeGruppoAutocomplete.search,
                loading: _ctx.aziendeGruppoAutocomplete.isLoading,
                options: _ctx.aziendeGruppoAutocomplete.options,
                modelValue: _ctx.aziendeGruppoAutocomplete.selection,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.aziendeGruppoAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "nome",
                class: "next-vue-multiselect-single",
                searchable: true,
                placeholder: "Azienda del gruppo",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            field_name: "Evento promo",
            errors: _ctx.getErrors('promo')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                modelValue: _ctx.progetto_model.promo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.progetto_model.promo) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              field_name: "Note",
              errors: _ctx.getErrors('note'),
              placeholder: "Note"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.progetto_model.note) = $event)),
                  class: "p-2 bg-next-gray-md-dark hover:bg-white h-full",
                  placeholder: "Note"
                }, null, 512), [
                  [_vModelText, _ctx.progetto_model.note]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, {
            field_name: "Cliente",
            required: !_ctx.clienteAutocomplete?.selection,
            errors: _ctx.getErrors('cliente_id'),
            placeholder: "Cliente"
          }, {
            help: _withCtx(() => _cache[18] || (_cache[18] = [
              _createElementVNode("span", { class: "pt-1 text-next-dark-gray text-xs" }, "Azienda alla quale si fattura", -1)
            ])),
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.clienteAutocomplete.search,
                loading: _ctx.clienteAutocomplete.isLoading,
                options: _ctx.clienteAutocomplete.options,
                modelValue: _ctx.clienteAutocomplete.selection,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clienteAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "denominazione",
                class: "next-vue-multiselect-single",
                placeholder: "Cliente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                option: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            field_name: "Committente",
            required: !_ctx.committenteAutocomplete?.selection,
            errors: _ctx.getErrors('committente_id'),
            placeholder: "Committente"
          }, {
            help: _withCtx(() => _cache[20] || (_cache[20] = [
              _createElementVNode("span", { class: "pt-1 text-next-dark-gray text-xs" }, "Azienda per la quale si svolge il lavoro", -1)
            ])),
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.committenteAutocomplete.search,
                loading: _ctx.committenteAutocomplete.isLoading,
                options: _ctx.committenteAutocomplete.options,
                modelValue: _ctx.committenteAutocomplete.selection,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.committenteAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "denominazione",
                class: "next-vue-multiselect-single",
                placeholder: "Committente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                option: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            field_name: "Titolo",
            required: !_ctx.progetto_model?.titolo?.length,
            errors: _ctx.getErrors('titolo'),
            modelValue: _ctx.progetto_model.titolo,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.progetto_model.titolo) = $event)),
            placeholder: "Nome del progetto"
          }, null, 8, ["required", "errors", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            field_name: "Descrizione",
            errors: _ctx.getErrors('descrizione'),
            modelValue: _ctx.progetto_model.descrizione,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.progetto_model.descrizione) = $event)),
            placeholder: "Descrizione"
          }, null, 8, ["errors", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            field_name: "Contatto cliente",
            required: false,
            errors: _ctx.getErrors('contatto_cliente')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.contattiAutocomplete.selection,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contattiAutocomplete.selection) = $event)),
                options: _ctx.contattiAutocomplete.options,
                multiple: true,
                onSearchChange: _ctx.searchContatti,
                "close-on-select": false,
                "clear-on-select": false,
                placeholder: "Contatto cliente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "full_name"
              }, {
                noResult: _withCtx(() => [
                  _withDirectives(_createElementVNode("span", null, "Nessun elemento trovato.", 512), [
                    [_vShow, _ctx.clienteAutocomplete.selection]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "Devi scegliere prima un cliente.", 512), [
                    [_vShow, !_ctx.clienteAutocomplete.selection]
                  ])
                ]),
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.full_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Field, {
            field_name: "Data inizio",
            required: !_ctx.progetto_model?.data_inizio,
            errors: _ctx.getErrors('data_inizio'),
            "input-attrs": {max: _ctx.progetto_model.data_fine},
            placeholder: "Data inizio",
            type: "date",
            modelValue: _ctx.progetto_model.data_inizio,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.progetto_model.data_inizio) = $event))
          }, null, 8, ["required", "errors", "input-attrs", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Field, {
            field_name: "Data di fine",
            required: !_ctx.progetto_model?.data_fine,
            errors: _ctx.getErrors('data_fine'),
            "input-attrs": {min: _ctx.progetto_model.data_inizio},
            placeholder: "Data di fine",
            type: "date",
            modelValue: _ctx.progetto_model.data_fine,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.progetto_model.data_fine) = $event))
          }, null, 8, ["required", "errors", "input-attrs", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Field, {
            field_name: " ",
            errors: _ctx.getErrors('assets')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FileUpload, {
                uploaded_files: _ctx.uploaded_files,
                "onUpdate:uploaded_files": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uploaded_files) = $event)),
                model_files: _ctx.sottoprogettoFiles,
                "onUpdate:model_files": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sottoprogettoFiles) = $event)),
                to_delete: _ctx.to_delete,
                "onUpdate:to_delete": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.to_delete) = $event)),
                multiple: "",
                accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
              }, {
                default: _withCtx(({props, methods}) => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: methods.open,
                      class: "w-full h-10 px-4 grow"
                    }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                        _createTextVNode(" Allega ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sottoprogettoFiles, (f, idx) => {
                        return (_openBlock(), _createElementBlock("a", _hoisted_17, [
                          _createElementVNode("span", null, _toDisplayString(f.name), 1),
                          (!_ctx.$attrs.readonly)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "icon icon-x ml-1",
                                onClick: ($event: any) => (methods.remove(_ctx.sottoprogettoFiles, idx))
                              }, null, 8, _hoisted_18))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.to_upload, (f, idx) => {
                        return (_openBlock(), _createElementBlock("a", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString(f.name), 1),
                          (!_ctx.$attrs.readonly)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "icon icon-x ml-1",
                                onClick: ($event: any) => (methods.remove(props.to_upload, idx))
                              }, null, 8, _hoisted_20))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_files, (f, idx) => {
                        return (_openBlock(), _createElementBlock("a", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(f.name), 1),
                          (!_ctx.$attrs.readonly)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "icon icon-x ml-1",
                                onClick: ($event: any) => (methods.remove(_ctx.uploaded_files, idx))
                              }, null, 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["uploaded_files", "model_files", "to_delete"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Field, {
            field_name: "Budget di apertura",
            required: !_ctx.progetto_model?.budget,
            errors: _ctx.getErrors('budget'),
            modelValue: _ctx.progetto_model.budget,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.progetto_model.budget) = $event)),
            placeholder: "Budget",
            type: "number",
            "input-attrs": {step:0.01}
          }, null, 8, ["required", "errors", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_Field, {
            field_name: "Budget presunto/da cliente",
            required: !_ctx.progetto_model?.budget_presunto?.toString(),
            errors: _ctx.getErrors('budget_presunto'),
            placeholder: "Budget presunto/da cliente"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                options: [{id: false, text: 'Da cliente'}, {id: true, text: 'Presunto'}],
                modelValue: _ctx.progetto_model.budget_presunto,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.progetto_model.budget_presunto) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _ctx.close,
              class: "px-4 xl:grow h-10"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _ctx.creaProgetto,
              disabled: _ctx.loading,
              loading: _ctx.loading,
              class: "px-4 xl:grow h-10 flex items-center justify-center"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
                  [_vShow, _ctx.$attrs['loading']]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.create ? 'Aggiungi' : 'Modifica'), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "loading"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}